var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M14.7948 11.6666C15.8298 11.6666 16.6689 12.5057 16.6689 13.5407V14.0202C16.6689 14.7654 16.4025 15.4861 15.9179 16.0523C14.6101 17.5802 12.6208 18.3342 9.99965 18.3342C7.3781 18.3342 5.38976 17.5799 4.0845 16.0514C3.60137 15.4856 3.33594 14.7661 3.33594 14.0221V13.5407C3.33594 12.5057 4.17498 11.6666 5.21 11.6666H10.0024H14.7948ZM14.7948 12.9166H5.21C4.86534 12.9166 4.58594 13.196 4.58594 13.5407V14.0221C4.58594 14.4685 4.7452 14.9002 5.03508 15.2397C6.0795 16.4627 7.71773 17.0842 9.99965 17.0842C12.2816 17.0842 13.9212 16.4627 14.9683 15.2394C15.2591 14.8997 15.4189 14.4673 15.4189 14.0202V13.5407C15.4189 13.196 15.1395 12.9166 14.7948 12.9166ZM9.99965 1.67053C12.3008 1.67053 14.1663 3.53601 14.1663 5.8372C14.1663 8.13839 12.3008 10.0039 9.99965 10.0039C7.69847 10.0039 5.83299 8.13839 5.83299 5.8372C5.83299 3.53601 7.69847 1.67053 9.99965 1.67053ZM9.99965 2.92053C8.38882 2.92053 7.08299 4.22637 7.08299 5.8372C7.08299 7.44803 8.38882 8.75387 9.99965 8.75387C11.6105 8.75387 12.9163 7.44803 12.9163 5.8372C12.9163 4.22637 11.6105 2.92053 9.99965 2.92053Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person2.77241f04896801f9c694d3b9bb3456bb.svg";
export { ForwardRef as ReactComponent };